import styled from "styled-components";

interface ICroppedImageProps {
    src: string;
    alt?: string;
}

const ImageContainer = styled.div`
    width: 128px;
    height: 32px;
    overflow: hidden;
    position: relative;
`;

const StyledImage = styled.img`
    width: 128px;
    height: 128px;
    object-fit: cover;
    object-position: center;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
`;

export const CroppedImage = ({ src, alt = "" }: ICroppedImageProps) => {
    return (
        <ImageContainer>
            <StyledImage src={src} alt={alt} />
        </ImageContainer>
    );
};